<template>
  <div id="award-type-edit">
    <v-card class="premium-checkout-card">
      <!-- Checkout Banner Header -->
      <div class="checkout-banner">
        <div class="hero-glow-effect"></div>
        <v-icon class="deco-icon icon-card" color="rgba(255, 255, 255, 0.08)"
          >mdi-trophy-outline</v-icon
        >
        <v-row class="ma-0 align-center relative-content">
          <v-col cols="10" class="text-left pa-0">
            <div class="banner-title d-flex align-center">
              <v-icon dark class="mr-2 pulse-animation"
                >mdi-pencil-circle</v-icon
              >
              {{ PageTitle || "Edit Award Type" }}
            </div>
            <p class="banner-subtitle">
              Modify and update the configuration for this award type.
            </p>
          </v-col>
          <v-col cols="2" class="text-right pa-0">
            <v-btn icon dark @click="closePrompt">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-card-text class="pt-4 card-content-area">
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="confirmAlert"
        >
          <v-container class="py-0">
            <v-row wrap>
              <v-col cols="12" md="12" class="pb-0">
                <p class="text-muted text-caption">
                  <span class="text-danger">*</span> indicates required field
                </p>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="6" lg="4" md="6" class="py-2">
                <label class="filter-label"
                  ><span class="text-danger">* </span> Award Category</label
                >
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="AwardCategoryOptions"
                  :rules="AwardCategoryRules"
                  v-model="AwardCategory"
                  placeholder="Select Category"
                  dense
                  clearable
                  required
                  outlined
                  rounded
                  class="premium-select"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" lg="4" md="6" class="py-2">
                <label class="filter-label"
                  ><span class="text-danger">*</span> Award Type Group</label
                >
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="AwardTypeGroupOptions"
                  :rules="AwardTypeGroupRules"
                  v-model="AwardTypeGroup"
                  placeholder="Select Group"
                  dense
                  clearable
                  required
                  outlined
                  rounded
                  class="premium-select"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" lg="4" md="6" class="py-2">
                <label class="filter-label"
                  ><span class="text-danger">*</span> Award Type Number</label
                >
                <v-text-field
                  v-model="AwardTypeNumber"
                  placeholder="Award Category Name"
                  :rules="AwardTypeNumberRules"
                  type="number"
                  min="1"
                  required
                  outlined
                  rounded
                  dense
                  class="premium-select"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="12" md="12" class="py-2">
                <label class="filter-label"
                  ><span class="text-danger">*</span> Award Type Title</label
                >
                <v-text-field
                  v-model="AwardTypeTitle"
                  placeholder="Award Type Title"
                  :rules="AwardTypeTitleRules"
                  required
                  outlined
                  rounded
                  dense
                  class="premium-select"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-row wrap class="mt-4">
            <v-col align="center" cols="12" md="12">
              <v-btn
                :disabled="!valid1"
                @click.prevent="confirmAlert"
                :loading="SubmitFlag"
                rounded
                large
                class="filter-btn btn-search white--text mr-3"
              >
                Submit
              </v-btn>
              <v-btn
                @click="closePrompt"
                rounded
                large
                outlined
                class="filter-btn btn-clear"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    editRecordPrompt: {
      required: true,
      type: Boolean,
    },
    AwardTypeId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SubmitFlag: false,

      UploadFlag: false,
      ResultFlag: false,

      AwardCategoryRules: [(v) => !!v || "Award Category is required"],
      AwardCategory: "",
      AwardCategoryOptions: [],

      AwardTypeGroupRules: [(v) => !!v || "Award Type Group is required"],
      AwardTypeGroup: "",
      AwardTypeGroupOptions: [],

      AwardTypeNumberRules: [
        (v) => !!v || "Award Type Number is required",
        (v) => (v && v >= 1) || "Questions Chars Count minimum 1",
      ],
      AwardTypeNumber: "",

      AwardTypeTitleRules: [(v) => !!v || "Award Type Title is required"],
      AwardTypeTitle: "",

      YearCode: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        this.YearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;
        var AwardTypeId = this.AwardTypeId;
        console.log({ AwardTypeId });

        this.pageData();
      }
    },
    AwardCategoryOptions: function () {
      console.log("watch AwardCategoryOptions");
      this.AwardCategoryOptionsLoading = false;
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "award_type",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.LoadingFlag = false;
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditRecordPrompt", this.ResultFlag);
    },

    pageData() {
      console.log("pageData called");
      this.getAwardCategoryOptions();
      this.getAwardTypeGroupOptions();
      this.getTableRecords();
    },
    getAwardCategoryOptions() {
      console.log("getAwardCategoryOptions called");
      var selectbox1_source = "AwardCategory";
      var selectbox1_destination = "AwardCategoryOptions";
      var selectbox1_url = "api/award-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getAwardTypeGroupOptions() {
      console.log("getAwardTypeGroupOptions called");
      var selectbox1_source = "AwardTypeGroup";
      var selectbox1_destination = "AwardTypeGroupOptions";
      var selectbox1_url = "api/award-group/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardTypeId = this.AwardTypeId;
      console.log({ AwardTypeId });

      if (AwardTypeId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/show";
        var upload = {
          UserInterface: 1,
          AwardType: AwardTypeId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.RecordFlag = flag;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.AwardTypeId = records.AwardTypeId;
              thisIns.AwardCategory = records.AwardCategoryId;
              thisIns.AwardTypeGroup = records.AwardGroupId;
              thisIns.AwardTypeNumber = records.AwardTypeNumber;
              thisIns.AwardTypeTitle = records.AwardTypeTitle;

              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award Type details not found.";
        console.log("error=" + message);
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        // this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.SubmitFlag = true;
      this.ResultFlag = false;

      var upload = {
        UserInterface: 1,
        Year: this.YearCode,
        AwardType: this.AwardTypeId,
        AwardCategory: this.AwardCategory,
        AwardTypeGroup: this.AwardTypeGroup,
        AwardTypeNumber: this.AwardTypeNumber,
        AwardTypeTitle: this.AwardTypeTitle,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/award-type/update";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.SubmitFlag = true;

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SubmitFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.ResultFlag = true;
            thisIns.closePrompt();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
        });
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

.premium-checkout-card {
  font-family: "Outfit", "Plus Jakarta Sans", sans-serif;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(21, 101, 192, 0.18) !important;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
}

.checkout-banner {
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 50%, #42a5f5 100%);
  padding: 30px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
  color: white;
}

.banner-title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 8px;
}

.banner-subtitle {
  font-size: 13px;
  opacity: 0.9;
  margin-top: 4px;
  margin-bottom: 0;
}

.card-content-area {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.8) 0%,
    #ffffff 100%
  );
}

.filter-label {
  font-size: 12px;
  font-weight: 700;
  color: #455a64;
  margin-bottom: 6px;
  display: block;
}

/* Autocomplete/Select box rounded controls */
.premium-select >>> .v-input__control > .v-input__slot {
  border-radius: 12px !important;
  border: 1.5px solid rgba(21, 101, 192, 0.1) !important;
  background-color: white !important;
  transition: all 0.3s ease !important;
}

.premium-select >>> .v-input__control > .v-input__slot:hover {
  border-color: rgba(21, 101, 192, 0.35) !important;
}

.premium-select.v-input--is-focused >>> .v-input__control > .v-input__slot {
  border-color: #1565c0 !important;
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.15) !important;
}

/* Action buttons */
.filter-btn {
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.btn-clear {
  color: #455a64 !important;
  border: 1.5px solid rgba(69, 90, 100, 0.2) !important;
}

.btn-clear:hover {
  background-color: rgba(69, 90, 100, 0.05) !important;
  border-color: #455a64 !important;
}

.btn-search {
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 100%) !important;
  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.3) !important;
  border: none !important;
}

.btn-search:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(21, 101, 192, 0.45) !important;
}

/* Decorative background icons */
.deco-icon {
  position: absolute !important;
  z-index: 1;
  pointer-events: none;
}

.icon-card {
  font-size: 110px !important;
  right: 20%;
  top: -20px;
  transform: rotate(15deg);
  animation: floatDeco 12s infinite ease-in-out;
}

/* Animations */
.hero-glow-effect {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 0;
  pointer-events: none;
}

.hero-glow-effect::after {
  content: "";
  position: absolute;
  top: 0;
  left: -50%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.15) 30%,
    rgba(255, 255, 255, 0) 60%
  );
  transform: skewX(-25deg);
  animation: shineSweep 6s infinite ease-in-out;
}

.relative-content {
  position: relative;
  z-index: 2;
}

.pulse-animation {
  animation: pulseIcon 3s infinite ease-in-out;
}

@keyframes shineSweep {
  0% {
    left: -120%;
  }
  15%,
  100% {
    left: 120%;
  }
}

@keyframes floatDeco {
  0%,
  100% {
    transform: translateY(0) rotate(15deg) scale(1);
  }
  50% {
    transform: translateY(-12px) rotate(20deg) scale(1.03);
  }
}

@keyframes pulseIcon {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
  50% {
    transform: scale(1.08);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.6));
  }
}
</style>
